<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div [ngClass]="{ wrap: wrapContent }">
  <div class="demographics-print-header print-header">
    <div *ngIf="!payload.properties.hideLabel?.value && payload.properties.text?.value">
      <div class="header">
        <div class="title">
          <span [innerHTML]="payload.properties.text?.value | tokenToDiv"></span>
          <span *ngIf="payload.properties.required?.value" class="required-asterisk">*</span>
        </div>
        <span class="message">* populated from PatientNow</span>
      </div>
    </div>

    <div class="flex flex-row" *ngIf="payload.properties.content?.value">
      <div class="flex word-wrap mb10">
        <label class="flex subtitle">
          <span [innerHTML]="payload.properties.content?.value | tokenToDiv"></span>
        </label>
      </div>
    </div>

    <mat-divider></mat-divider>
  </div>

  <div class="demographics-container">
    <!-- Design or Preview Mode -->
    <div class="demographics-content">
      <div *ngFor="let item of payload.properties.items?.value; let categoryIndex = index">
        <!-- Nested categories (like Personal Information, Address) -->
        <div
          *ngIf="isNestedCategory(item) && item.value"
          class="demographics-category"
          [class.demographics-category--first]="isFirstVisibleNestedCategory(categoryIndex)"
        >
          <h3 class="category-title">{{ getCategoryTitle(item) }}</h3>
          <!-- Fields displayed in two columns -->
          <div class="demographics-fields-grid">
            <ng-container *ngFor="let field of getFields(item); let i = index">
              <ng-container *ngIf="field.visible">
                <div class="demographics-field" [ngClass]="getColumnClass(i)">
                  <div class="field-label">
                    <span class="field-label-content">
                      <span>{{ field.title }}</span>
                      <span class="required-mark" *ngIf="field.required">*</span>
                      <fb-scribe-suggestion-indicator [target]="field"></fb-scribe-suggestion-indicator>
                      <fb-amendment-field-indicator [fieldKey]="'c' + categoryIndex + ':f' + i" />
                    </span>
                  </div>
                  <div class="field-value">
                    <!-- Dropdown fields -->
                    <div *ngIf="field.type === 'dropdown'" class="field-wrapper">
                      <div class="input-wrapper">
                        <rx-states
                          *ngIf="field.title === 'State'"
                          [hidePlaceHolder]="this.isPrinting || this.isPreview"
                          [field]="getDisplayField(field)"
                          (modelChangeEmit)="clearMarker(field)"
                          [ngClass]="{ 'has-conflict': isConflicting(field) && !isRxPortal && mode !== 'kiosk' }"
                        ></rx-states>
                        <ng-select
                          *ngIf="field.title !== 'State'"
                          [ngModel]="displayValue(field)"
                          (ngModelChange)="onValueChange(field, $event)"
                          [items]="field?.options || []"
                          [bindLabel]="field?.optionLabelKey || 'title'"
                          [bindValue]="field?.optionValueKey || 'value'"
                          [closeOnSelect]="true"
                          [searchable]="false"
                          [placeholder]="field?.placeholder || ''"
                          class="demographics-select"
                          [ngClass]="{ 'has-conflict': isConflicting(field) && !isRxPortal && mode !== 'kiosk' }"
                          [disabled]="isPreview || isPrinting"
                          [required]="field.required"
                        >
                        </ng-select>
                        <rx-icon
                          *ngIf="isConflicting(field) && !isRxPortal && mode !== 'kiosk'"
                          name="icon-warning-circle"
                          class="conflict-warning-icon"
                          [title]="field.conflictTooltip || 'Conflict detected'"
                          (click)="toggleTooltip($event)"
                        ></rx-icon>
                      </div>
                      <div
                        class="field-error"
                        *ngIf="isSubmitted && field.required && (!field.value || field.value === '')"
                      >
                        {{ field.title }} is required
                      </div>
                    </div>

                    <!-- Date fields -->
                    <div *ngIf="field.type === 'date'" class="field-wrapper">
                      <div class="input-wrapper">
                        <input
                          type="date"
                          [ngModel]="displayValue(field)"
                          (ngModelChange)="onValueChange(field, $event)"
                          placeholder="MM/DD/YYYY"
                          class="demographics-input"
                          [ngClass]="{ 'has-conflict': isConflicting(field) && !isRxPortal && mode !== 'kiosk' }"
                          [readonly]="isPreview || isPrinting"
                          [required]="field.required"
                        />
                        <rx-icon
                          *ngIf="isConflicting(field) && !isRxPortal && mode !== 'kiosk'"
                          name="icon-warning-circle"
                          class="conflict-warning-icon"
                          [title]="field.conflictTooltip || 'Conflict detected'"
                          (click)="toggleTooltip($event)"
                        ></rx-icon>
                      </div>
                      <div
                        class="field-error"
                        *ngIf="isSubmitted && field.required && (!field.value || field.value === '')"
                      >
                        {{ field.title }} is required
                      </div>
                    </div>

                    <!-- Text fields -->
                    <div
                      *ngIf="field.type === 'text' || (field.type !== 'dropdown' && field.type !== 'date')"
                      class="field-wrapper"
                    >
                      <div class="input-wrapper">
                        <input
                          type="text"
                          [ngModel]="displayValue(field)"
                          (ngModelChange)="onValueChange(field, $event)"
                          [placeholder]="field.placeholder || ''"
                          class="demographics-input"
                          [ngClass]="{ 'has-conflict': isConflicting(field) && !isRxPortal && mode !== 'kiosk' }"
                          [readonly]="isPreview || isPrinting"
                          [required]="field.required"
                        />
                        <rx-icon
                          *ngIf="isConflicting(field) && !isRxPortal && mode !== 'kiosk'"
                          name="icon-warning-circle"
                          class="conflict-warning-icon"
                          [title]="field.conflictTooltip || 'Conflict detected'"
                          (click)="toggleTooltip($event)"
                        ></rx-icon>
                      </div>
                      <div
                        class="field-error"
                        *ngIf="isSubmitted && field.required && (!field.value || field.value === '')"
                      >
                        {{ field.title }} is required
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <div *ngIf="!isNestedCategory(item) && item.visible" class="demographics-single-field">
          <div class="field-label">
            <span class="field-label-content">
              <span>{{ item.title }}</span>
              <span class="required-mark" *ngIf="item.required">*</span>
              <fb-scribe-suggestion-indicator [target]="item"></fb-scribe-suggestion-indicator>
              <fb-amendment-field-indicator [fieldKey]="'c' + categoryIndex" />
            </span>
          </div>
          <div class="field-value">
            <div *ngIf="item.title === 'Gender'" class="field-wrapper">
              <div class="input-wrapper">
                <ng-select
                  [ngModel]="displayValue(item)"
                  (ngModelChange)="onValueChange(item, $event)"
                  [clearable]="false"
                  [searchable]="false"
                  placeholder="Select Gender"
                  class="demographics-select"
                  [ngClass]="{ 'has-conflict': isConflicting(item) && !isSubmissionPending() && mode !== 'kiosk' }"
                  [disabled]="isPreview || isPrinting"
                  [required]="item.required"
                >
                  <ng-option value="male">Male</ng-option>
                  <ng-option value="female">Female</ng-option>
                  <ng-option value="unknown">Unknown</ng-option>
                  <ng-option value="other">Others</ng-option>
                </ng-select>
                <rx-icon
                  *ngIf="isConflicting(item) && !isSubmissionPending() && mode !== 'kiosk'"
                  name="icon-warning-circle"
                  class="conflict-warning-icon"
                  [title]="item.conflictTooltip || 'Conflict detected'"
                  (click)="toggleTooltip($event)"
                ></rx-icon>
              </div>
              <div class="field-error" *ngIf="isSubmitted && item.required && (!item.value || item.value === '')">
                {{ item.title }} is required
              </div>
            </div>

            <div *ngIf="item.title === 'Birthday'" class="field-wrapper">
              <div class="input-wrapper">
                <input
                  type="date"
                  [ngModel]="displayValue(item)"
                  (ngModelChange)="onValueChange(item, $event)"
                  placeholder="MM/DD/YYYY"
                  class="demographics-input"
                  [ngClass]="{ 'has-conflict': isConflicting(item) && !isSubmissionPending() }"
                  [readonly]="isPreview || isPrinting"
                  [required]="item.required"
                />
                <rx-icon
                  *ngIf="isConflicting(item) && !isSubmissionPending() && mode !== 'kiosk'"
                  name="icon-warning-circle"
                  class="conflict-warning-icon"
                  [title]="item.conflictTooltip || 'Conflict detected'"
                  (click)="toggleTooltip($event)"
                ></rx-icon>
              </div>
              <div class="field-error" *ngIf="isSubmitted && item.required && (!item.value || item.value === '')">
                {{ item.title }} is required
              </div>
            </div>

            <div *ngIf="item.title !== 'Gender' && item.title !== 'Birthday'" class="field-wrapper">
              <div class="input-wrapper">
                <input
                  type="text"
                  [ngModel]="displayValue(item)"
                  (ngModelChange)="onValueChange(item, $event)"
                  [placeholder]="item.placeholder || ''"
                  class="demographics-input"
                  [ngClass]="{ 'has-conflict': isConflicting(item) && !isSubmissionPending() }"
                  [readonly]="isPreview || isPrinting"
                  [required]="item.required"
                />
                <rx-icon
                  *ngIf="isConflicting(item) && !isSubmissionPending() && mode !== 'kiosk'"
                  name="icon-warning-circle"
                  class="conflict-warning-icon"
                  [title]="item.conflictTooltip || 'Conflict detected'"
                  (click)="toggleTooltip($event)"
                ></rx-icon>
              </div>
              <div class="field-error" *ngIf="isSubmitted && item.required && (!item.value || item.value === '')">
                {{ item.title }} is required
              </div>
            </div>
          </div>
        </div>
      </div>

      <p *ngIf="!hasVisibleCategories() && isPreview" class="placeholder">
        Demographics information will be populated from patient records
      </p>
    </div>

    <div class="demographics-content" *ngIf="!isDesign && !isPrinting">
      <p *ngIf="!payload.properties.value?.value" class="placeholder">
        Demographics information will be populated from patient records
      </p>
      <div *ngIf="payload.properties.value?.value" [innerHTML]="payload.properties.value?.value | tokenToDiv"></div>
    </div>
  </div>

  <!-- <div *ngIf="payload.properties.hint?.value"
         class="hint"
         [innerHTML]="payload.properties.hint?.value | tokenToDiv"></div>
    <div *ngIf="payload.properties.required?.value && isSubmitted && !isValid()"
         class="hint-required">
        {{ getValidationErrorMessage() }}
    </div> -->
</div>
